import { Tkv2PublicRecord } from '@aloft/toolkit-shared';

export function getAssessedLandToValueRatio(
  publicRecordData: Tkv2PublicRecord | undefined,
): number | null {
  if (!publicRecordData) {
    return null;
  }

  const { TaxAssessedValueImprovements, TaxAssessedValueLand } = publicRecordData;
  const TaxAssessedLandPlusImprovements = TaxAssessedValueImprovements?.add(TaxAssessedValueLand);

  return TaxAssessedLandPlusImprovements &&
    TaxAssessedValueLand &&
    TaxAssessedLandPlusImprovements.unitAmount > 0
    ? TaxAssessedValueLand.ratio(TaxAssessedLandPlusImprovements)
    : null;
}
